'use client';

import { useTranslations } from 'next-intl';
import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';
import { Icon } from '@/shared/ui/icon';
import { ModalService } from '@/shared/ui/modal/ModalService';
import './blog-cta-bar.scss';

type Props = ComponentPropsWithRef<'div'>;
export const BlogCTABar = ({ className, ...props }: Props) => {
    const t = useTranslations();

    const handleSubscribe = () => {
        // TODO: Implement subscription logic and show register modal only when not logged in
        ModalService.showPrefab('RegisterModal', {});
    };

    return (
        <div className={cn('blog-cta-bar', className)} data-testid="blog-cta-bar" {...props}>
            <p className="blog-cta-bar__description" data-testid="blog-cta-bar-description">
                {t('BLOG.CTA_BAR.DESCRIPTION')}
            </p>
            <Button
                className="blog-cta-bar__button"
                data-testid="blog-cta-bar-button"
                onClick={handleSubscribe}
            >
                <Icon name="send" />
                {t('BLOG.CTA_BAR.BUTTON')}
            </Button>
        </div>
    );
};
